<script lang="ts">
  import * as Dialog from '$lib/components/ui/dialog';
  import type { Conversation } from './api';

  // Every conversation the current user belongs to is a valid forward target for a plain
  // message -- unlike Comments' forward picker, there's no server-side eligibility filter
  // needed here, so this just lists what the thread container already has loaded.
  export let open: boolean;
  export let conversations: Conversation[];
  export let currentUserId: number;
  export let onPick: (conversationId: string) => void;

  function label(c: Conversation): string {
    const others = c.participants.filter((p) => p.id !== currentUserId);
    const names = others.map((p) => `${p.first_name} ${p.last_name}`.trim()).join(', ');
    return names || c.name || 'Conversation';
  }

  function pick(conversationId: string) {
    onPick(conversationId);
    open = false;
  }
</script>

<Dialog.Root portal="#shadcn-ui-dialog-target" bind:open>
  <Dialog.Content class="max-w-sm">
    <Dialog.Header>
      <Dialog.Title>Forward to…</Dialog.Title>
    </Dialog.Header>
    <div class="flex max-h-80 flex-col gap-1 overflow-y-auto">
      {#each conversations as c (c.id)}
        <button type="button" class="block w-full rounded-md px-2 py-2 text-left text-sm hover:bg-muted" on:click={() => pick(c.id)}>
          {label(c)}
        </button>
      {/each}
      {#if conversations.length === 0}
        <p class="m-0 text-sm text-muted-foreground">No conversations to forward to.</p>
      {/if}
    </div>
  </Dialog.Content>
</Dialog.Root>
